// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  reactionId: __t.u64().primaryKey().name("reaction_id"),
  messageId: __t.u64().name("message_id"),
  userIdentity: __t.identity().name("user_identity"),
  emoji: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
